import React, { lazy } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';


const UsersView = lazy(() => import('../../container/crud/users/Index'));
const UsersAdd = lazy(() => import('../../container/crud/users/Add'));
const UsersResetPass = lazy(() => import('../../container/crud/users/ResetPass'));


const PagesRoute = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}/view`} component={UsersView} />
      <Route path={`${path}/add`} component={UsersAdd} />
      <Route exact path={`${path}/edit/:id`} component={UsersAdd} />
      <Route exact path={`${path}/resetpass/:id`} component={UsersResetPass} />

    </Switch>
  );
};

export default PagesRoute;
